// @flow

import React from 'react';
import CategorizedBulkBar from '../pills/categorized-bulk-bar';
import type { TagPermissionsT } from './use-tag-permissions';

type Props = {
  count: number,
  total: number,
  permissions: TagPermissionsT,
  onAddTag: () => void,
  onRemoveTag: () => void,
  onClear: () => void,
  onSelectAll: () => void,
};

const BulkBar = ({
  count,
  total,
  permissions,
  onAddTag,
  onRemoveTag,
  onClear,
  onSelectAll,
}: Props) => (
  <CategorizedBulkBar
    count={count}
    total={total}
    canBulkAdd={permissions.canBulkAssignTag}
    canBulkRemove={permissions.canBulkRemoveTag}
    addLabel="Add tag"
    removeLabel="Remove tag"
    addDisabledTooltip="You do not have permission to add tags to locations."
    removeDisabledTooltip="You do not have permission to remove tags from locations."
    onAdd={onAddTag}
    onRemove={onRemoveTag}
    onClear={onClear}
    onSelectAll={onSelectAll}
  />
);

export default BulkBar;
